<script setup lang="ts">
  import { format, addHours } from "date-fns";
  import { LiveInfo } from "~/entities/LiveInfo";
  import { useSnackBarStore } from "~/stores/SnackBarStore";

  // スナックバーstore
  const snackBarStore = useSnackBarStore();

  interface Props {
    liveInfo: LiveInfo;
  }
  const props = defineProps<Props>();

  const onClick = () => {
    try {
      // 終了時間は1時間後。Dateをutcで指定のフォーマットに変換できないので現地時間で指定する
      const startDateTime = format(new Date(props.liveInfo.liveScheduleDateTime), "yyyyMMdd'T'HHmmss");
      const endDateTime = format(addHours(new Date(props.liveInfo.liveScheduleDateTime), 1), "yyyyMMdd'T'HHmmss");

      // ベースURLを取得
      const baseUrl = window.location.origin;
      // スケジュールのLINKを作成
      const scheduleUrl = `${baseUrl}/plan/${props.liveInfo.plan?.id}/liveschedule/${props.liveInfo.id}`;

      // カレンダー登録用のテキストを作成
      const text = encodeURIComponent(`${props.liveInfo.contentsTitle}`);
      // カレンダー登録用の詳細を作成
      const details = encodeURIComponent(`${props.liveInfo.description}\n\n[ライブ参加URL]\n${scheduleUrl}\n`);
      // カレンダー登録用の日付を作成
      const dates = encodeURIComponent(`${startDateTime}/${endDateTime}`);
      // カレンダー登録用の場所を作成
      const location = encodeURIComponent(`${scheduleUrl}`);

      // google カレンダー登録用URL
      const googleCalendarUrl = `https://www.google.com/calendar/render?action=TEMPLATE&text=${text}&details=${details}&location=${location}&dates=${dates}`;
      // google カレンダーを新しいタブで開く
      window.open(googleCalendarUrl, "_blank");
    } catch (error: any) {
      snackBarStore.set("Googleカレンダーの登録に失敗しました" + error.message, "error");
      sentryErrorLog("Googleカレンダーの登録に失敗しました" + error.message);
    }
  };
</script>

<template>
  <v-btn class="btn-google-calendar" color="main-01" @click="onClick">
    <v-icon icon="$mdiGoogle" class="mr-2 google-icon" />予定を追加する
  </v-btn>
</template>

<style lang="scss" scoped>
  @import "assets/media.scss";
  .btn-google-calendar {
    font-size: 18px;
    font-weight: 700;
    line-height: 1.8em;
    padding: 0px 10px 0px 10px;
    border-color: white;
    border-style: solid;

    @include display_sp {
      font-size: 16px;
      font-weight: 700;
      line-height: 1.8em;
    }
  }
  .google-icon {
    font-size: 30px;
    width: 30px;
    height: 30px;
    @include display_sp {
      font-size: 25px;
      width: 25px;
      height: 25px;
    }
  }
</style>
